import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Trash2, AlertTriangle } from "lucide-react";
import { sumExpr } from "./imageUtils";

const MATCH_LABEL = { exact: "Exact", suggested: "Needs confirm", unmatched: "Not found", manual: "Chosen by you", new: "New customer (confirmed)" };

export const QtyInput = ({ entry, onChange, className = "" }) => (
  <div>
    <Input data-testid={`entry-tons-${entry.id}`} className={`h-8 w-28 ${className}`} value={entry.tons_text ?? ""} placeholder="e.g. 3+4.5"
      onChange={(e) => { const t = e.target.value.replace(/[^\d.+\s]/g, ""); onChange({ ...entry, tons_text: t, tons: sumExpr(t) }); }} />
    <div className="text-[10px] text-slate-500 mt-0.5">{entry.tons == null ? "unreadable" : `= ${entry.tons} t`}</div>
  </div>
);

export const EntryRow = ({ entry, res, customers, onChange, onDelete }) => {
  const set = (k, v) => onChange({ ...entry, [k]: v });
  const open = res?.issues?.length > 0;
  return (
    <tr data-testid={`entry-row-${entry.id}`} className={`border-b border-slate-100 align-top ${open ? "bg-amber-50/60" : ""}`}>
      <td className="p-1.5 text-xs text-slate-400">{entry.page ? `P${entry.page}` : "—"}
        {entry.crop && <img src={entry.crop} alt="line" className="mt-1 max-w-28 rounded border" />}</td>
      <td className="p-1.5"><Input type="date" data-testid={`entry-date-${entry.id}`} className="h-8 w-36" value={entry.date || ""} onChange={(e) => set("date", e.target.value)} /></td>
      <td className="p-1.5"><Input data-testid={`entry-name-${entry.id}`} className="h-8 min-w-32" value={entry.customer_read} onChange={(e) => onChange({ ...entry, customer_read: e.target.value, matched_customer: null, new_customer: false })} /></td>
      <td className="p-1.5">
        <select data-testid={`entry-match-${entry.id}`} className="h-8 rounded-md border border-slate-200 text-sm px-1 max-w-44"
          value={entry.matched_customer || ""} onChange={(e) => onChange({ ...entry, matched_customer: e.target.value || null, new_customer: false })}>
          <option value="">{res?.match_type === "exact" ? `Auto: ${res.matched_customer}` : "— choose customer —"}</option>
          {customers.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        {res && <div className={`text-[10px] mt-0.5 ${["unmatched", "suggested"].includes(res.match_type) ? "text-amber-700" : "text-slate-400"}`}>{MATCH_LABEL[res.match_type]}{res.suggestion ? `: ${res.suggestion}?` : ""}</div>}
      </td>
      <td className="p-1.5"><QtyInput entry={entry} onChange={onChange} /></td>
      <td className="p-1.5">
        {entry.uncertain || entry.overwritten ? (
          <label className="flex items-center gap-1.5 text-xs">
            <Checkbox data-testid={`entry-confirm-${entry.id}`} checked={entry.confirmed} onCheckedChange={(v) => set("confirmed", !!v)} />
            {entry.confirmed ? "Confirmed" : <span className="text-amber-700 flex items-center gap-1"><AlertTriangle className="h-3 w-3" />Confirm</span>}
          </label>
        ) : <span className="text-xs text-slate-400">Clear</span>}
        {entry.note && <div className="text-[10px] text-slate-500 max-w-48" title={entry.note}>{entry.note}</div>}
      </td>
      <td className="p-1.5"><button data-testid={`entry-delete-${entry.id}`} onClick={onDelete} className="text-slate-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button></td>
    </tr>
  );
};

export const EntryTable = ({ entries, resolution, customers, onUpdate, onDelete }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead><tr className="text-left text-xs text-slate-500 border-b">
        <th className="p-1.5">Page</th><th className="p-1.5">Date</th><th className="p-1.5">Name as read</th>
        <th className="p-1.5">Website customer</th><th className="p-1.5">Qty (as written)</th><th className="p-1.5">Reading</th><th />
      </tr></thead>
      <tbody>
        {entries.map((e) => (
          <EntryRow key={e.id} entry={e} res={resolution[e.id]} customers={customers}
            onChange={onUpdate} onDelete={() => onDelete(e.id)} />
        ))}
      </tbody>
    </table>
  </div>
);
